module.exports = __webpack_public_path__ + "img/mood4.9359e3c6.png";